
import './App.css';
import Texts from './displayMessage.js'
import AuthGuard from './authenticator.js'
import Header from './header.js';
import { useState } from 'react';
import { zenoConfig } from "./configs/zeno.js";

function App() {
  const [dark, setDark] = useState(false);

  const theme = dark ? zenoConfig.dark : zenoConfig.light;
  const toggleDark = () => {
    setDark(prevDark => !prevDark);
  };

  return (
    <AuthGuard>
    <div className="App " style={{
    "--header-bg": theme.background,
    "--text-clr" :theme.text
  }}>

     <Header name={zenoConfig.name} mode={dark} style={{
    "--header-bg": theme.text,
    "--text-clr" :theme.background
  }}></Header>
    
      <header className="App-header">
         <button onClick={toggleDark}>
          {dark ? "Toggle Light Mode" : "Toggle Dark Mode"}
        </button>
       
        <Texts name={zenoConfig.name} />
      
      </header>
    </div>
    </AuthGuard>
  );
}

export default App;
